import React from "react";
import axios from "axios";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  faCircleCheck,
  faXmarkCircle,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../components/button";
import { useDispatch, useSelector } from "react-redux";
import ReactLoading from "react-loading";
import { EMenuActions } from "../../store";
import { CompanyActions } from "../../store/company_dtl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PaystackButton } from "react-paystack";

export default function PlaceOrder({ msg }) {
  let dispatch = useDispatch();
  let navigate = useNavigate();

  const auth_token = useSelector((state) => state.Company.auth_token);
  const placeOrder = useSelector((state) => state.EMenu.placeOrder);
  const available_table = useSelector((state) => state.Company.available_table);
  const cartItems = useSelector((state) => state.EMenu.cartItems);
  const m_id = useSelector((state) => state.Company.m_id);
  const c_url = useSelector((state) => state.Company.c_url);
  const indoor_selected_value = useSelector(
    (state) => state.EMenu.indoor_selected_value
  );
  const approvedOrder = useSelector((state) => state.EMenu.approvedOrder);
  const selected_tableId = useSelector(
    (state) => state.Company.selected_tableId 
  );
  const orderId = useSelector((state) => state.EMenu.emenuOrderId);
  const price = useSelector((state) => state.EMenu.TotalPrice);
  const userName = useSelector((state) => state.User.userName);
  const userPhone = useSelector((state) => state.User.userPhone);
  const publicKey = useSelector((state) => state.Company.paystack_pk);
  const email = useSelector((state) => state.User.userEmail);
  const acceptAwaiting = useSelector((state) => state.EMenu.acceptAwaiting);
  const acceptStatus = useSelector((state) => state.EMenu.acceptStatus);
  const holdApproval = useSelector((state) => state.EMenu.holdApproval);
  const chargeType = useSelector((state) => state.Tax.chargeType);
  const inclusiveTotal = useSelector((state) => state.Tax.incTotal);
  const exclusiveTotal = useSelector((state) => state.Tax.exclTotal);
  const tableid = useSelector((state) => state.Company.tableId);
  const amount = chargeType === "1" ? price : exclusiveTotal;
  const [isClicked, setIsClicked] = React.useState(false);

  const componentProps = {
    email: email,
    amount: amount * 100,
    metadata: {
      userName,
      userPhone,
    },
    publicKey,
    cartItems,
    text: "Proceed",
    onSuccess: () =>
      setTimeout(() => {
        dispatch(EMenuActions.setPlaceOrder(false));
        localStorage.removeItem("cartItems");
        dispatch(EMenuActions.setCartItems([]));
        dispatch(CompanyActions.setSL_TB(""));
        navigate(`/${m_id}/menu`);
        dispatch(EMenuActions.setAcceptAwaiting(true));
        dispatch(EMenuActions.setEmenuOrderId(""));
        localStorage.setItem("orderId");
        dispatch(EMenuActions.setAcceptStatus(""));
        dispatch(EMenuActions.setHoldApproval([]));
        dispatch(EMenuActions.clearApprovedOrder());
      }, 2000),
    onClose: () => alert("Wait! Don't leave"),
  };

  const navigateToHome = () => {
    if (available_table) {
      navigate(`/${m_id}/menu`);
    } else {
      navigate(`/${tableid}/tablemenu`);
    }
  };
  const handleCompleteOrder = async () => {
    setIsClicked(true);
    const sendApproval = {
      products: {}, // Initialize an empty object for products
      action: "accept", // Set the action property
      orderId: orderId,
    };
    if (acceptStatus === "8") {
      toast.info("Cannot proceed with order", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else if (acceptStatus === "3") {
      toast.success("Sending your order...", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      await approvedOrder.forEach((item) => {
        // console.log(item.ProductId);
        const productData = {
          Accept: "3",
        };
        const productObject = {
          [item.ProductId]: productData,
        };

        // Assign the productObject to the products object
        Object.assign(sendApproval.products, productObject);
      });
      try {
        const submitOrder = await axios.post(
          `https://${c_url}/api/v1/Orders/customerProcessOrder`,
          sendApproval,
          {
            headers: {
              Authorization: `${auth_token}`,
            },
          }
        );
        if (submitOrder.status === 200 || submitOrder.status === 201) {
          // console.log("good");
          toast.success("Order has been received.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setTimeout(() => {
            dispatch(EMenuActions.setPlaceOrder(false));
            localStorage.removeItem("cartItems");
            dispatch(EMenuActions.setCartItems([]));
            dispatch(CompanyActions.setSL_TB(""));
            navigate(`/${m_id}/menu`);
            dispatch(EMenuActions.setAcceptAwaiting(true));
            dispatch(EMenuActions.setEmenuOrderId(""));
            localStorage.removeItem("orderId");
            dispatch(EMenuActions.setAcceptStatus(""));
            dispatch(EMenuActions.setHoldApproval([]));
            dispatch(EMenuActions.clearApprovedOrder());
          }, 1000);
        }
      } catch (e) {
        console.warn("error", e);
      }
    }
  };

  const handleCancelOrder = () => {
    dispatch(EMenuActions.setConfirmCancel(true));
  };

  const showApprovalStatus = (itemStatus) => {
    if (acceptStatus === "3" && (itemStatus === "3" || itemStatus === "1")) {
      return (
        <FontAwesomeIcon
          icon={faCircleCheck}
          size="sm"
          className="max-md:items-center w-[50%] h-[50%] p-2rounded-lg max-sm:w-[60%] max-sm:h-[60%]"
        />
      );
    } else if (
      acceptStatus === "8" ||
      itemStatus === "8" ||
      itemStatus === "1"
    ) {
      return (
        <FontAwesomeIcon
          icon={faXmarkCircle}
          size="sm"
          className="max-md:items-center w-[50%] h-[50%] p-2rounded-lg max-sm:w-[60%] max-sm:h-[60%]"
        />
      );
    }
    return null;
  };

  React.useEffect(() => {
    const intervalDuration = 2000;

    const getApproval = async () => {
      try {
        if (acceptAwaiting) {
          const response = await axios.get(
            `https://${c_url}/api/v1/Orders/VerifyStatusByOrderIdTableId/${orderId}/${selected_tableId}`,
            {
              headers: {
                Authorization: `${auth_token}`,
              },
            }
          );
          if (Array.isArray(response.data)) {
            if (
              response.data[0].orderInfo.Status === "3" ||
              response.data[0].orderInfo.Status === "8"
            ) {
              dispatch(
                EMenuActions.setHoldApproval(response.data[0].orderItems)
              );
              if (holdApproval.length > approvedOrder.length) {
                holdApproval.forEach((item) => {
                  dispatch(EMenuActions.setApprovedOrder(item));
                });
              }
              dispatch(
                EMenuActions.setAcceptStatus(response.data[0].orderInfo.Status)
              );
            }
          }
        }
      } catch (e) {
        console.warn("error fetching info: ", e);
      }
    };

    // Start the interval and store the interval ID
    const intervalId = setInterval(() => {
      if (
        approvedOrder.length >= holdApproval.length &&
        approvedOrder.length > 0
      ) {
        clearInterval(intervalId);
        dispatch(EMenuActions.setAcceptAwaiting(false));
      }
      getApproval();
    }, intervalDuration);
    // Cleanup function to clear the interval when the component is unmounted
    return () => {
      clearInterval(intervalId);
    };
  }, [acceptAwaiting, approvedOrder, holdApproval, acceptStatus]);

  const handleClose = () => {
    dispatch(EMenuActions.setPlaceOrder(!placeOrder));
  };

  return (
    <section className="bg-dark/50 overflow-hidden fixed z-40 min-h-screen top-0 left-0 right-0 bottom-0">
      <div className="relative">
        <div className="md:w-[90%] lg:w-[70%] xl:w-[50%] max-sm:w-[90%] m-auto bg-white rounded-lg md:my-2 md:pt-2 max-sm:p-1 max-sm:mt-20">
          <div
            className={`${
              acceptAwaiting ? "hidden" : ""
            } absolute max-sm:right-5 max-sm:-top3 md:right-2 lg:right-20 xl:right-72 -top-3 p-4 cursor-pointer`}
            onClick={handleClose}
          >
            <FontAwesomeIcon
              icon={faXmark}
              size="xl"
              className="text-light p-2 border-light border-2 rounded-lg bg-primaryLight/30 "
            />
          </div>
          <div className="flex flex-col gap-3 h-[65vh] max-sm:justify-around max-sm:h-[50vh] mt-6 p-14 max-sm:p-10">
            {holdApproval.length > 0 && approvedOrder.length > 0 ? (
              <div className="w-full overflow-y-scroll h-[30vh] max-md:h-[30vh]">
                {approvedOrder.map((order, index) => {
                  return (
                    <div
                      key={index}
                      className="flex item-start justify-between w-full mb-2 max-sm:text-2xl max-sm:mb-5"
                    >
                      <div className="w-2/3 flex">
                        <span className="whitespace-nowrap text-ellipsis overflow-hidden max-md:w-[90%] max-md:font-bold w-[60%]">
                          {order.ProductName}
                        </span>
                        <span className="whitespace-nowrap max-md:font-bold md:w-full w-[20%] text-end">
                          {parseInt(order.Quantity)}
                        </span>
                      </div>
                      <div className={`flex w-[20%] justify-end`}>
                        {acceptAwaiting ? (
                          <ReactLoading
                            type={"spin"}
                            color="#09ad2d"
                            height={"50%"}
                            width={"50%"}
                          />
                        ) : (
                          <div
                            className={`flex w-full justify-end max-md:items-center max-md:font-bold ${
                              acceptStatus === "3" &&
                              (order.ItemStatus === "3" ||
                                order.ItemStatus === "1")
                                ? "text-secondary"
                                : "text-danger"
                            }`}
                          >
                            {showApprovalStatus(order.ItemStatus)}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="flex w-full justify-center">
                <ReactLoading
                  type={"spin"}
                  color="#ccc"
                  height={"30%"}
                  width={"30%"}
                />
              </div>
            )}
            <p className="w-full flex justify-between pt-1 pb-3 text-lg font-black">
              <span>Total with Tax</span>
              <span>
                {amount.toLocaleString("en-NG", {
                  style: "currency",
                  currency: "NGN",
                })}
              </span>
            </p>
            <p className="text-xl font-extrabold text-center text-dark mt-1 mb-5">
              <span className={`${acceptStatus ? "" : "hidden"}`}>
                {acceptStatus === "3" ? (
                  <span>Order placed Successfully</span>
                ) : (
                  <span>Could not fulfil your order</span>
                )}
              </span>
            </p>
            <span
              className={`${
                acceptStatus ? "text-sm hidden" : "text-lg font-bold"
              } mt-2 text-dark/80 text-center md:w-[100%] max-sm:w-[80%] m-auto`}
            >
              Kindly hold on for confirmation of order
            </span>
          </div>
          {!acceptAwaiting && (
            <div className="pb-5 flex  justify-between mx-5">
              <button
                className="bg-light font-bold rounded text-white py-3 px-5 hover:bg-light/70"
                onClick={handleCancelOrder}
              >
                {" "}
                Cancel
              </button>
              {indoor_selected_value === "unpaid" && (
                <button
                  className="bg-secondary font-bold rounded text-white py-3 px-5 hover:bg-secondary/70"
                  disabled={isClicked}
                  onClick={handleCompleteOrder}
                >
                  {" "}
                  Proceed
                </button>
              )}
              {indoor_selected_value === "paid" && (
                <PaystackButton
                  className="bg-secondary text-white font-bold p-3 text-sm rounded uppercase flex justify-center"
                  {...componentProps}
                  onClick={handleCompleteOrder}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
